import { render, staticRenderFns } from "./resultInfo.vue?vue&type=template&id=195c37b6&scoped=true"
import script from "./resultInfo.vue?vue&type=script&lang=js"
export * from "./resultInfo.vue?vue&type=script&lang=js"
import style0 from "./resultInfo.vue?vue&type=style&index=0&id=195c37b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c37b6",
  null
  
)

export default component.exports